import { render, staticRenderFns } from "./divier.vue?vue&type=template&id=b4a711cc&scoped=true&"
import script from "./divier.vue?vue&type=script&lang=js&"
export * from "./divier.vue?vue&type=script&lang=js&"
import style0 from "./divier.vue?vue&type=style&index=0&id=b4a711cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a711cc",
  null
  
)

component.options.__file = "divier.vue"
export default component.exports